// runtime
export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const START_LOAD = 'START_LOAD';
export const END_LOAD = 'END_LOAD';
export const CUSTOM_ERROR_LOAD = 'CUSTOM_ERROR_LOAD';
export const ERROR_LOAD = 'ERROR_LOAD';
export const ADD_PAGE_LOAD = 'ADD_PAGE_LOAD';
export const END_LOAD_FIRST = 'END_LOAD_FIRST';
export const END_LOAD_LAST = 'END_LOAD_LAST';
export const END_LOAD_FIRST_EMPTY = 'END_LOAD_FIRST_EMPTY';
export const UPDATE_SPEC_DATA = 'UPDATE_SPEC_DATA';
export const RESET_RUNTIME = 'RESET_RUNTIME';
export const END_LOAD_REMOVE = 'END_LOAD_REMOVE';
export const ADD_ARR_ELEM = 'ADD_ARR_ELEM';
export const SPLICE_ARR_ELEM = 'SPLICE_ARR_ELEM';
export const LAZY_START = 'LAZY_START';
export const MERGE_RUNTIME = 'MERGE_RUNTIME';

// localization
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

// form
export const CHANGE_OPEN_FIELD = 'CHANGE_OPEN_FIELD';



// WEBPACK FOOTER //
// ./src/constants/actions.js